export var SwitchCheckbox = _ref => {
  var {
    borderColor,
    borderSelectedColor,
    checkboxColor,
    textColor
  } = _ref;
  return _ref2 => {
    var {
      checked,
      focused,
      error,
      warning
    } = _ref2;
    return {
      boxStyle: checked && !error && !warning && checkboxColor != null && borderSelectedColor != null && borderColor != null ? {
        backgroundColor: checkboxColor.toString(),
        borderColor: (focused ? borderSelectedColor : borderColor).toString()
      } : {},
      checkedBoxStyle: checked && !error && !warning && checkboxColor != null && borderSelectedColor != null && borderColor != null ? {
        backgroundColor: checkboxColor.toString(),
        borderColor: (focused ? borderSelectedColor : borderColor).toString()
      } : {},
      textStyle: checked && !error && !warning && textColor != null ? {
        color: textColor.toString()
      } : {}
    };
  };
};
//# sourceMappingURL=SwitchCheckbox.js.map